import { Document } from "@models";
import { Edit } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { DocStatus, DocumentStatus } from "@types";
import GenericButton from "src/components/GenericButton/GenericButton";
import { UPGRADE_PLAN_TOOLTIP } from "../../../../../utils";

//UNAPPROVED: show edit button -> pencil icon
//LIVE: show "New revision" button (disabled if draft already exists)
//DRAFT / ARCHIVED / other: no button shown (handled by parent)

export const EditButton = ({
  loadingNewDocVersion,
  onEditClick,
  selectedDoc,
  isDocEnabled,
  docVersionStatus,
  hasDraft,
}: {
  loadingNewDocVersion: boolean;
  onEditClick?: (document: Document) => void;
  selectedDoc: Document;
  isDocEnabled: boolean;
  docVersionStatus: DocStatus;
  hasDraft?: boolean;
}) => {
  const handleClick = () => {
    onEditClick?.(selectedDoc);
  };

  const getEditButton = (docVersionStatus: DocStatus) => {
    if (docVersionStatus === DocumentStatus.LIVE) {
      const isDisabled = !isDocEnabled || loadingNewDocVersion || !!hasDraft;
      const tooltipContent = hasDraft
        ? "A draft version already exists. Please edit or remove it."
        : UPGRADE_PLAN_TOOLTIP;
      const hideTooltip = hasDraft ? false : isDocEnabled;

      return (
        <GenericButton
          isDisabled={isDisabled}
          onClick={handleClick}
          tooltipContent={tooltipContent}
          hideTooltip={hideTooltip}
          text="New revision"
        />
      );
    }

    if (docVersionStatus === DocumentStatus.UNAPPROVED) {
      return (
        <GenericButton
          isDisabled={!isDocEnabled || loadingNewDocVersion}
          id="basic-button"
          onClick={handleClick}
          tooltipContent={UPGRADE_PLAN_TOOLTIP}
          hideTooltip={isDocEnabled}
        >
          {loadingNewDocVersion ? (
            <CircularProgress size={"1rem"} color="inherit" />
          ) : (
            <Edit fontSize="small" data-testid="edit-button-document" />
          )}
        </GenericButton>
      );
    }

    return null;
  };

  return getEditButton(docVersionStatus);
};

export default EditButton;
